/* eslint-disable react/jsx-no-literals */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import { TextField } from '@material-ui/core'
import styles from './InputMoons.module.scss'

/**
 * reuable generic input moons
 * @param {*} param0 .
 * @returns {Void} compoent
 */
export const InputMoons = ({
  placeholder, required, className = '', multiline = false, ...rest
}) => {
  const _multiline = multiline ? { multiline, rows: 4 } : {}

  return (
    <TextField
      label={placeholder}
      {...rest}
      placeholder=""
      variant="filled"
      size="small"
      {..._multiline}
      row={4}
      className={[styles.inputMoons,
        className,
        required ? 'required' : ''].join(' ')}
    />
  )
}
